import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Color from '../Color.js';
var sqrt = Math.sqrt,
  pow = Math.pow,
  min = Math.min,
  max = Math.max,
  atan2 = Math.atan2,
  abs = Math.abs,
  cos = Math.cos,
  sin = Math.sin,
  exp = Math.exp,
  PI = Math.PI;
export default function (a, b) {
  var Kl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var Kc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var Kh = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  // Delta E (CIE 2000)
  // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
  var rad2deg = function rad2deg(rad) {
    return 360 * rad / (2 * PI);
  };
  var deg2rad = function deg2rad(deg) {
    return 2 * PI * deg / 360;
  };
  a = new Color(a);
  b = new Color(b);
  var _Array$from = Array.from(a.lab()),
    _Array$from2 = _slicedToArray(_Array$from, 3),
    L1 = _Array$from2[0],
    a1 = _Array$from2[1],
    b1 = _Array$from2[2];
  var _Array$from3 = Array.from(b.lab()),
    _Array$from4 = _slicedToArray(_Array$from3, 3),
    L2 = _Array$from4[0],
    a2 = _Array$from4[1],
    b2 = _Array$from4[2];
  var avgL = (L1 + L2) / 2;
  var C1 = sqrt(pow(a1, 2) + pow(b1, 2));
  var C2 = sqrt(pow(a2, 2) + pow(b2, 2));
  var avgC = (C1 + C2) / 2;
  var G = 0.5 * (1 - sqrt(pow(avgC, 7) / (pow(avgC, 7) + pow(25, 7))));
  var a1p = a1 * (1 + G);
  var a2p = a2 * (1 + G);
  var C1p = sqrt(pow(a1p, 2) + pow(b1, 2));
  var C2p = sqrt(pow(a2p, 2) + pow(b2, 2));
  var avgCp = (C1p + C2p) / 2;
  var arctan1 = rad2deg(atan2(b1, a1p));
  var arctan2 = rad2deg(atan2(b2, a2p));
  var h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
  var h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
  var avgHp = abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
  var T = 1 - 0.17 * cos(deg2rad(avgHp - 30)) + 0.24 * cos(deg2rad(2 * avgHp)) + 0.32 * cos(deg2rad(3 * avgHp + 6)) - 0.2 * cos(deg2rad(4 * avgHp - 63));
  var deltaHp = h2p - h1p;
  deltaHp = abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
  deltaHp = 2 * sqrt(C1p * C2p) * sin(deg2rad(deltaHp) / 2);
  var deltaL = L2 - L1;
  var deltaCp = C2p - C1p;
  var sl = 1 + 0.015 * pow(avgL - 50, 2) / sqrt(20 + pow(avgL - 50, 2));
  var sc = 1 + 0.045 * avgCp;
  var sh = 1 + 0.015 * avgCp * T;
  var deltaTheta = 30 * exp(-pow((avgHp - 275) / 25, 2));
  var Rc = 2 * sqrt(pow(avgCp, 7) / (pow(avgCp, 7) + pow(25, 7)));
  var Rt = -Rc * sin(2 * deg2rad(deltaTheta));
  var result = sqrt(pow(deltaL / (Kl * sl), 2) + pow(deltaCp / (Kc * sc), 2) + pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
  return max(0, min(100, result));
}